import { IReleaseAndAssignee, ITestPlanOption } from '@/api/testRun';
import { InputField } from '@/components/form/fields/InputField';
import { SelectField } from '@/components/form/fields/SelectField';
import { TextAreaField } from '@/components/form/fields/TextAreaField';
import React from 'react';

type TestRunProps = {
  optionsData?: IReleaseAndAssignee;
  optionsPlan?: ITestPlanOption;
};

export const TestRunForm: React.FC<TestRunProps> = ({
  optionsData,
  optionsPlan,
}) => {
  return (
    <div className="grid gap-2.5">
      <div className="flex gap-5">
        <InputField
          name="title"
          label="Name"
          placeholder="Test Run Name"
          hasRequiredAsterisk
        />

        <InputField
          name="version"
          label="Version"
          placeholder="Enter The Version"
        />

        <InputField
          name="browser"
          label="Browser"
          placeholder="Enter The Browser Name"
        />
      </div>

      <div className="flex gap-5">
        <SelectField
          options={optionsData?.release}
          name="release_id"
          label="Release"
          hasRequiredAsterisk
          isSearchable
        />

        <SelectField
          options={optionsData?.assign}
          name="assignee_id"
          label="Assign to"
          hasRequiredAsterisk
          isSearchable
        />

        <SelectField
          options={optionsPlan?.testPlan}
          name="test_plan_id"
          label="Test Plan"
          isSearchable
        />
      </div>

      <TextAreaField
        name="description"
        label="Description"
      />

      <SelectField name="custom_field_id" label="Custom Field" />
    </div>
  );
};
